import React from 'react'
import { Link } from 'gatsby'
import Icon from './Icon'

const AnchorChevron = ({ href, copy }) => {
  return (
    <Link
      className={`flex text-lg text-secondary justify-between items-start w-full hover:underline hover:text-primary`}
      to={href}
    >
      <span className="flex-1 pr-4">{copy}</span>
      <Icon icon="forwardArrow" className="w-2 h-5 opacity-50 fill-current" />
    </Link>
  )
}

export default AnchorChevron
